export const MIN_PASSWORD_LENGTH = 8
export const MAX_PASSWORD_LENGTH = 128
export const EMAIL_ERROR = 'email'
export const SUBMIT_BUTTON_FALLBACK = "Let's go!"
export const PASSWORD_TOO_LONG_FALLBACK =
  'Password must be less than 129 characters'

export const INVALID_EMAIL_ERROR = 'is invalid'
export const NOT_VALID_FALLBACK =
  'Use your personal email, not your student one'

export const RECAPTCHA_ERROR_TEXT = 'Recaptcha is invalid, please try again'
export const RECAPTCHA_ERROR = 'RECAPTCHA FAILED'
export const CREATE_BUTTON_FALLBACK = 'Create account'
